import { Box, useMediaQuery, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

import { SUB_HEADER_PAGE_ELEMENT_ID } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export function SubHeader({ children }: Readonly<PropsWithChildren<{}>>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const bgColor = isMobile ? 'transparent' : NEW_COLORS.BASE.WHITE;
  return (
    <Box bgcolor={bgColor} id={SUB_HEADER_PAGE_ELEMENT_ID}>
      {children}
    </Box>
  );
}
